export const DEFAULT_OTP_COOLDOWN = 10;
export const TABLE_LIMIT_OPTION_MIN = 25;
export const TABLE_LIMIT_OPTION_PITCH = 25;
export const TABLE_LIMIT_OPTION_COUNT = 4;
export const TABLE_LIMITS_OPTIONS = new Array(TABLE_LIMIT_OPTION_COUNT)
  .fill(0)
  .map((_, i) => TABLE_LIMIT_OPTION_MIN + TABLE_LIMIT_OPTION_PITCH * i);
export const MAIN_CONTENT_ID = 'cpms-bo-content';
